module.exports = "<div class=\"video-group\">    \r\n    <div class=\"btn toggler group-info\">\r\n        <div class=\"btn btn-small\">\r\n            <i class=\"icon-chevron-up\" />\r\n            <i class=\"icon-chevron-down\" />\r\n        </div>\r\n        <span data-bind=\"group-title\"></span>\r\n        <span class=\"duration\" data-bind=\"group-duration\"></span>\r\n    </div>\r\n    <ul data-bind=\"videos\">\r\n    </ul>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/video/videoGroupView.html
 ** module id = 23
 ** module chunks = 0
 **/